module.exports = __webpack_public_path__ + "img/bg-line-1-phone.7df99ce1.png";